// extracted by mini-css-extract-plugin
export default {"wrapper":"data-account-success-modal_wrapper__X7AQ3","button":"data-account-success-modal_button__A8h7F","opacity-transition":"data-account-success-modal_opacity-transition__rs8+T"};